import React from "react";
import { Link } from "react-router-dom";
import logoIcon from "../../assets/pnrbet-icon.png";
import { ENTITY, ADDRESS, LAST_UPDATED } from "../../legal/common";
import { openCookiePreferences } from "@/lib/cookieConsent";

// Shared chrome for every public legal/policy page. Matches the existing
// standalone legal page design (dark surface, max-w-3xl column, display font).
export default function LegalLayout({ policy, children }) {
  return (
    <div className="min-h-[100dvh] bg-surface-1 text-white">
      <header className="border-b border-surface-border">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-3 px-4 py-4 pt-[max(1rem,env(safe-area-inset-top))] sm:px-6">
          <Link to="/" className="flex items-center gap-2 focus-ring" data-testid="legal-home-link">
            <img src={logoIcon} alt="" className="h-10 w-10 rounded-md" />
            <span className="font-display text-lg font-extrabold tracking-tighter">PRYMEBET</span>
          </Link>
          <div className="flex items-center gap-3 sm:gap-4">
            <Link to="/legal" className="text-sm font-medium text-meta underline underline-offset-2 transition-colors hover:text-white focus-ring" data-testid="legal-hub-link">Legal &amp; Policies</Link>
            <Link to="/" className="hidden text-sm font-medium text-meta underline underline-offset-2 transition-colors hover:text-white focus-ring sm:inline">Back to home</Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 pb-[max(3rem,env(safe-area-inset-bottom))] sm:px-6 sm:py-12">
        <p className="mb-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-pnr-green">{policy.category || "Legal"}</p>
        <h1 className="font-display text-3xl font-black tracking-tight sm:text-5xl sm:tracking-tighter" data-testid="legal-title">{policy.title}</h1>

        <p className="mt-3 text-sm text-meta" data-testid="legal-effective">Effective date: {policy.effectiveDate}</p>
        <p className="mt-2 text-xs text-[#71717a]" data-testid="legal-updated">Last updated: {policy.lastUpdated || LAST_UPDATED}</p>

        <div className="mt-6">{children}</div>

        <div className="mt-10 rounded-2xl border border-surface-border bg-surface-3 p-5 text-xs leading-relaxed text-meta" data-testid="legal-footer-disclaimer">
          NO PURCHASE NECESSARY. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF WINNING. MUST BE 18+ (or the age of majority in your
          jurisdiction, whichever is greater). VOID WHERE PROHIBITED. Operated by {ENTITY}, {ADDRESS}.{" "}
          <Link to="/legal" className="text-pnr-green underline underline-offset-2 hover:text-white focus-ring">See all PrymeBet legal &amp; policy documents</Link>.{" "}
          <button type="button" onClick={openCookiePreferences} data-testid="legal-cookie-prefs" className="text-pnr-green underline underline-offset-2 hover:text-white focus-ring">Cookie Preferences</button>.
        </div>
      </main>
    </div>
  );
}
